import { type ReactNode } from 'react';
import { useWorkspaceFeature } from '@frontend/workspace-scope';
import { WorkspaceScopedDeviceSection } from './workspace-scoped-device-section';

type DeviceSectionWrapperProps = {
  children: ReactNode;
};

/**
 * Isolated wrapper that subscribes to workspace stores so the parent Profile
 * component is never re-rendered by workspace state changes.
 *
 * - Not in workspace mode → renders children (normal DeviceSection).
 * - In workspace mode → delegates to WorkspaceScopedDeviceSection.
 */
export const DeviceSectionWrapper = ({ children }: DeviceSectionWrapperProps) => {
  const { isWorkspaceMode } = useWorkspaceFeature();

  if (!isWorkspaceMode) {
    return <>{children}</>;
  }

  return <WorkspaceScopedDeviceSection />;
};
